module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ModalTheme', {
    attrs: {
      "with-content": true,
      "theme": true
    },
    on: {
      "close": _vm.closeModal
    }
  }, [_c('template', {
    slot: "main"
  }, [(_vm.brandId) ? _c('NotificationLists', {
    ref: "notificationList",
    attrs: {
      "brandId": _vm.brandId
    },
    on: {
      "cancel": _vm.closeModal
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('template', {
    slot: "footer"
  }, [_c('ClientColorButton', {
    attrs: {
      "disabled": !_vm.isDirty
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.closeModal($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("common.cancel")))]), _vm._v(" "), _c('ClientColorButton', {
    attrs: {
      "disabled": !_vm.isDirty
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v(_vm._s(_vm.$t("common.save")) + " ")])], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-13286872","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/notifcation-lists/NotificationListsModal.vue
// module id = 3026
// module chunks = 0